import {
  NumberParam,
  QueryParamConfigMap,
  StringParam,
  withDefault,
} from 'common/hooks/customSearchParams';

export const CREDENTIALS_QUERY_PARAMS: QueryParamConfigMap = {
  sortBy: StringParam,
  sortOrder: StringParam,
  page: withDefault(NumberParam, 1),
  pageSize: withDefault(NumberParam, 25),
  search: StringParam,
};
